import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const xrd = {
    jpath: ['spectra', 'xrd'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xrd;
//# sourceMappingURL=xrd.js.map